import {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import FilterPayment from "./FilterPayment";
import {statusList, typeList} from "./lists";
import {numberWithPoints} from "../../../utils/numberWithPoints";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import {useUser} from "../../../auth/AuthProvider";
import PaymentsReport from "../../PaymentsToAprove/Components/PaymentsReport";
import PaymentActions from "./PaymentActions";
import DownloadToAproveReport from "../../PaymentsToAprove/Components/DownloadToAproveReport";
import PopupExportPagamentos from "./PopupExportPagamentos";
import DownloadAllFiles from "./DownloadAllFiles";

export default function PaymentList({
                                        baseUrl, loadData,
                                        filter, setFilter,
                                        setLoadData, size, page,
                                        setTotalPages, setTotalElements,
                                        sort, setPage,
                                        displayReport
                                    }) {

    const {user} = useUser()

    const [data, setData] = useState([])
    const [error, setError] = useState(false)

    const titles = user.isAdmin ? [
        'Data de Agendamento',
        'Valor',
        'Status',
        'Tipo',
        'Banco',
        'Meio',
        'Participante',
    ] : [
        'Data de Agendamento',
        'Valor',
        'Status',
        'Tipo',
        'Banco',
        'Meio',
    ]

    return (
        <>
            <FilterPayment filter={filter} setFilter={setFilter} setLoadData={setLoadData} setPage={setPage}/>
            {displayReport ? <>
                <DownloadToAproveReport filter={filter}/>
                <PaymentsReport data={data}/>
            </> : <>
                <DownloadAllFiles type={'receipt'} data={data}/>
                <DownloadAllFiles type={'report'} data={data}/>
            </>}
            {/*<PopupAddAnimal baseUrl={baseUrl} setLoadData={setLoadData}/>*/}
            <TableList
                titles={titles} baseUrl={baseUrl}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError} isFilterByUser={!user.isAdmin}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{normalizeTimestemp(item.scheduledDate, true)}</td>
                        <td>R$ {numberWithPoints(item.valor)}</td>
                        <td>{statusList.filter(stt => stt.value === item.status)[0].label}</td>
                        <td>{typeList.filter(type => type.value === item.tipoPagamento)[0].label}</td>
                        <td>{item.banco}</td>
                        <td>{item.meioPagamento}</td>
                        {user.isAdmin && <>
                            <td>{item.participante.nome} - {item.participante.documento}</td>
                        </>}
                        <td><PaymentActions item={item} setLoadData={setLoadData}/></td>
                    </tr>
                )}
            </TableList>
            <br/>
            {user?.isAdmin &&
                <PopupExportPagamentos filter={filter}/>
            }
        </>
    )
}